import phishBoxSlice from "../slices/phishBoxSlice";

export const {
  SetPhishBoxActiveTab,
  RequestPhishBoxList,
  SuccessPhishBoxList,
  FailurePhishBoxList,
  SetDynamicPhishingActiveTab,
  RequestDynamicPhishingEmails,
  SuccessDynamicPhishingEmails,
  FailureDynamicPhishingEmails,
} = phishBoxSlice.actions;
